export default [{
    id: "37601",
    name: "Hadassah Medical Center, Ein-Karem",
},{
    id: "37602",
    name: "The Chaim Sheba Medical Center",
}, ];